// Okabe-Ito color blind firendly palette
// ##         black        orange       skyblue   bluishgreen        yellow
// ##     "#000000"     "#E69F00"     "#56B4E9"     "#009E73"     "#F0E442"
// ##          blue    vermillion reddishpurple          gray
// ##     "#0072B2"     "#D55E00"     "#CC79A7"     "#999999"

export const Colors = [
  {
    name: 'orange',
    value: '#E69F00'
  },
  {
    name: 'skyblue',
    value: '#56B4E9'
  },
  {
    name: 'bluishgreen',
    value: '#009E73'
  },
  {
    name: 'yellow',
    value: '#F0E442'
  },
  {
    name: 'blue',
    value: '#0072B2'
  },
  {
    name: 'vermillion',
    value: '#D55E00'
  },
  {
    name: 'reddishpurple',
    value: '#CC79A7'
  },
  {
    name: 'gray',
    value: '#999999'
  },
  {
    name: 'black',
    value: '#000000'
  }
];
